import React, {
  createContext, useContext, useState, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const defaultValue = null;

export const HouseholdStatsContext = createContext(defaultValue);

export function HouseholdStatsContextProvider({ children }) {
  const { householdResource } = useSimpleHousehold();
  const [householdStatsResource, setHouseholdStatsResource] = useState(null);

  const handleHouseholdStatsRefresh = async () => {
    if (!householdResource?.relationship(fr.relationships.householdStats.name)) {
      return;
    }
    try {
      const [householdStatsRes] = await householdResource.relationship(fr.relationships.householdStats.name).link('related').get();
      setHouseholdStatsResource(householdStatsRes);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };


  useEffect(() => {
    if (householdResource) {
      handleHouseholdStatsRefresh();
    }
  }, [householdResource]);

  return (
    <HouseholdStatsContext.Provider
      value={{
        householdStatsResource,
        handleHouseholdStatsRefresh,
      }}
    >
      {children}
    </HouseholdStatsContext.Provider>
  );
}

HouseholdStatsContextProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

function useHouseholdStatsContext() {
  const context = useContext(HouseholdStatsContext);

  if (!context) throw new Error('useUser must be called from a UserContext.Provider');

  return context;
}

export default useHouseholdStatsContext;

export const withUserContextAdapter = Wrapped => props => {
  const householdStatsContext = useHouseholdStatsContext();

  return (
    <Wrapped HouseholdStatsContext={{ ...householdStatsContext }} {...props} {...householdStatsContext} />
  );
};
